import { Image as ImageType } from "shared/types";
import Image from "shared/images";

type ProjectImageType = {
    image: ImageType;
    text: string;
}

export const ProjectImage = (props: ProjectImageType) => {

    const {image, text} = props;

    return (

        <div className="project-image">
            <div className="desc" dangerouslySetInnerHTML={{__html:text}} />
            <div className="image">  <Image name={image} title="" />  </div>
         </div>
    );

}
